import React from 'react'

import CarouselWrapper from './CarouselWrapper'
import Icon from './Icon'

import styles from '../scss/ui/tray.scss'

class Tray extends React.Component {
    constructor() {
        super()
        this.state = {
            visible: true,
        }

        this.trayToggle = this.trayToggle.bind(this)
    }

    trayToggle() {
        this.setState(prevState => ({ visible: !prevState.visible }))
    }

    render() {
        const { visible } = this.state

        return (
            <div className={styles.tray} aria-hidden={visible ? 'false' : 'true'}>
                <button
                    type="button"
                    className={styles.trayButton}
                    onClick={this.trayToggle}
                >
                    <Icon
                        icon="caret-down"
                        size={3}
                        color="lighter"
                        className={visible ? styles.trayIcon : styles.trayIconFlipped}
                    />
                </button>
                <CarouselWrapper />
            </div>
        )
    }
}

export default Tray



// WEBPACK FOOTER //
// ./src/ui/Tray.js